<script setup>
import { onMounted } from 'vue';
import { router } from '@inertiajs/vue3';
import Layout from "../Components/Layout.vue";

defineProps({
    plan: Object,
});

onMounted(() => {
    Telegram.WebApp.MainButton.hide();
    Telegram.WebApp.BackButton.show();
    Telegram.WebApp.BackButton.onClick(() => router.get('/'));
});
</script>

<template>
    <Layout>
        <div class="p-4 space-y-4 bg-tgThemeSecondaryBgColor">
            <h1 class="text-2xl font-semibold">Оплата прошла успешно 🥳</h1>

            <div class="p-6 bg-tgThemeSectionBgColor rounded-lg">
                <p>Ваш тариф &laquo;{{ plan.name }}&raquo; подключен на 1&nbsp;месяц!</p>
                <p class="mt-4">Автоматических списаний нет. Через месяц я напомню о продлении 👌</p>
            </div>
        </div>
    </Layout>
</template>
